import { styled } from '@linaria/react';

function FinalButton({ stage, children }) {
  const Wrapper = stage === 'shadow' ? BaseWrapper : FinalWrapper;
  const Backdrop =
    stage === 'shadow' ? ShadowBackdrop : FinalBackdrop;

  return (
    <Wrapper>
      <Shadow />
      <Backdrop />
      <Contents>{children}</Contents>
    </Wrapper>
  );
}

const BaseWrapper = styled.button`
  position: relative;
  width: 180px;
  text-align: center;
  user-select: none;
  -webkit-tap-highlight-color: transparent;

  &:focus {
    outline-offset: 4px;
  }
`;

const FinalWrapper = styled(BaseWrapper)`
  transition: filter 600ms;
  transition: filter 600ms;

  &:hover {
    transition: filter 250ms;
    filter: brightness(110%);
  }
`;

const Shadow = styled.span`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: hsl(0deg 0% 0% / 0.2);
  border-radius: 12px;
  /* Mouse-out styles */
  transform: translateY(3px);
  transition: all 600ms cubic-bezier(0.3, 0.7, 0.4, 1);
  will-change: transform;

  ${BaseWrapper}:hover &,
  ${BaseWrapper}:focus-visible & {
    transform: translateY(4px);
    transition: all 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
  }
  ${BaseWrapper}:active & {
    transform: translateY(1px);
    transition: all 25ms;
  }
`;

const BaseBackdrop = styled.span`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  /* prettier-ignore */
  border-radius: 12px;
`;

const ShadowBackdrop = styled(BaseBackdrop)`
  background: hsl(340deg, 100%, 32%);
`;
const FinalBackdrop = styled(BaseBackdrop)`
  background: linear-gradient(
    to left,
    hsl(340deg 100% 20%) 0%,
    hsl(340deg 100% 32%) 7%,
    hsl(340deg 100% 32%) 93%,
    hsl(340deg 100% 20%) 100%
  );
`;

const Contents = styled.span`
  position: relative;
  display: block;
  background: hsl(345deg, 100%, 46.5%);
  padding: 12px 42px;
  color: white;
  border-radius: 12px;
  font-weight: bold;
  font-size: 20px;
  /* Mouse-out styles */
  transform: translateY(-4px);
  transition: all 600ms cubic-bezier(0.3, 0.7, 0.4, 1);
  will-change: transform;

  ${BaseWrapper}:hover &,
  ${BaseWrapper}:focus-visible & {
    transform: translateY(-6px);
    transition: all 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
  }
  ${BaseWrapper}:active & {
    transform: translateY(-2px);
    transition: all 25ms;
  }
`;

export default FinalButton;
